import publicApi from "../publicApi";
import { useMutation } from "@tanstack/vue-query";

export interface CreateAccount {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  security_question_id: number;
  security_answer: string;
  continue_despite_sso_warning: boolean;
}

const createAccount = async (accountData: CreateAccount) => {
  const response = await publicApi.post("/users", accountData);

  return response.data;
};

const useCreateAccountMutation = () => {
  return useMutation({
    mutationFn: ({ accountData }: { accountData: CreateAccount }) => createAccount(accountData)
  });
};

export default useCreateAccountMutation;
